import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConnectionService } from '../../connection.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';;

@Component({
  selector: 'app-inner-search',
  templateUrl: './inner-search.component.html',
  styleUrls: ['./inner-search.component.css']
})
export class InnerSearchComponent implements OnInit {

  searchobj: any = {
    searchAddress: ''
  }
  openCard: boolean = false;
  searchType: string;
  searchData: any;
  accounts: any;
  Srep: any;
  sr: any;
  user_contract: any;
  contractName: any;
  ABC_Contract: string;
  token_name: any;

  constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute) { }

  ngOnInit() {
  }

  getSearchsuggestion(event: any, search: any) {
    if (search != '') {
      this.openCard = true;
      if (search.length == 34) {
        this.conn.getUsers(`users/suggestions`, 'searchquery', search).subscribe((res: any) => {
          if (!res.error && res.user) {
            this.searchType = 'Accounts'
            this.accounts = res.user[0]
            this.sr = ''
          }
          else if (!res.error && res.sr) {
            this.searchType = 'SR'
            this.sr = res.sr[0]
            this.accounts = ''

          }
          else if (!res.error && res.usercontract) {
            this.searchType = 'Contracts'
            this.user_contract = res.usercontract[0]
            this.contractName = res.name
          }
          else if (search == 'Scdpjg1Cp5pfJuB29rGCavVEDekY4kRSYh' || search == 'SbZgDdiSKabXhJbDV7VNere98s1basgN3A') {
            this.searchType = 'Contracts'
            this.ABC_Contract = search
          }
          else {
            this.openCard = false
            this.searchType = 'No Data Found'
          }
          if (event.keyCode == 13) {
            this.openCard = false
            this.searchobj.searchAddress = ''
          }
        })
      }
      else if (search.includes("http://") || search.includes("https://")) {
        this.conn.getUsers(`users/suggestions`, 'searchquery', search).subscribe((res: any) => {
          if (!res.error) {
            this.searchType = 'SR'
            this.Srep = res[0]
          }
          else {
            this.openCard = false
            this.searchType = 'No Data Found'
          }
          if (event.keyCode == 13) {
            this.openCard = false
            this.searchobj.searchAddress = ''
          }
        })
      }
      else {
        this.conn.getUsers(`users/suggestions`, 'searchquery', search).subscribe((res: any) => {
          if (!res.error) {
            this.searchType = 'Tokens'
            this.searchData = res
          }
          else {
            this.openCard = false
            this.searchType = 'No Data Found'
          }
          if (event.keyCode == 13) {
            this.openCard = false
            this.searchobj.searchAddress = ''
          }
        })
      }
    }
    else {
      this.openCard = false
    }
  }

  changeStatus() {
    setTimeout(() => {
      this.conn.setRoute.emit(true)
      this.searchobj.searchAddress = ''
    }, 500)
  }

  getTypeData(type: any, search: any) {
    if (type == 'transHash' || type == 'blockNumber' || type == 'token') {
      if (search.length == 34) {
        this.openCard = false
      }
    }
    else {
      this.getSearchsuggestion(search, type)
    }
  }

  searchDetails(event: any, type: any, search: any) {
    if (search != ''){
      if (event.keyCode == 13) {
        if (type == 'address') {
          if (search.length == 34) {
            this.route.navigate(['/account-details/', search])
          }
          else {
            this.alert.error('Search not found')
          }
        }
        else if (type == 'transHash') {
          if (search.length == 64) {
            this.route.navigate(['trans-details', search])
          }
          else {
            this.alert.error('Search not found')
          }
        }
        else if (type == 'blockNumber') {
          if (search.length == 7) {
            this.route.navigate(['/tag/', type, search])
          }
          else {
            this.alert.error('Search not found')
          }
        }
        else if (type == undefined && search.includes('00000000')) {
          this.route.navigate(['/block-hash', search])
        }
        else if (type == 'token') {
          this.token_name = search
          if (this.token_name == 'ABC10') {
            this.route.navigate(['contracts-triggers', this.token_name, '1000001'])
          }
        }
        else if (type == undefined && search.length == 34 && this.searchType != 'Contracts') {
          this.route.navigate(['/account-details', search])
          setTimeout(() => {
            this.conn.setRoute.emit(true)
          }, 2000)
        }
        else if (type == undefined && search.length == 34 && this.searchType == 'Contracts') {
          this.route.navigate(['/contract-methods', search])
        }
        else if (type == undefined && search.length == 64) {
          this.route.navigate(['/trans-details', search])
        }
        else if (type == undefined && search.length <= 7) {
          this.route.navigate(['/tag/', 'allFilters', search])
          setTimeout(() => {
            this.conn.setBlock.emit(true)
          }, 2000)
        }
        else {
          this.alert.error('Search not found')
        }
      }
    }
    else {
    }  
  }

  removeSpace(event: any) {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }
}
